import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";
import useRolesListAnalytics from "../useRolesListAnalytics";

type RolesListItemDescriptionCellProps = CellComponentProps;

const RolesListItemDescriptionCell = ({ role }: RolesListItemDescriptionCellProps) => {
  const trackAnalytics = useRolesListAnalytics();

  const handleShowFullDescription = () => {
    trackAnalytics("Show full description clicked");
  };

  if (!role.description) {
    return null;
  }

  return (
    <Box direction="row" align="start">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={role.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </Box>
  );
};

export default RolesListItemDescriptionCell;
